import { FC, MouseEvent, ReactNode } from 'react';
import { Text, TextProps } from '@connect-x-app/hybrid-ui';
import { IconName } from '@connect-x-app/shared-types';
import { COLORS } from '@connect-x-app/shared-ui';
import { partTestId } from '@connect-x-app/shared-utils';
import classNames from 'classnames';

import { Icon } from '../icon';

import './SideModal.scss';

type Props = {
  bottomButtons?: ReactNode;
  className?: string;
  content?: ReactNode;
  fullwidth?: boolean;
  header: SideModalHeader;
  isVisible?: boolean;
  onBackgroundClick?: () => void;
  placement?: 'left' | 'right';
  testId?: string;
};

export type SideModalHeader = {
  backgroundColor?: string;
  leftIcon?: {
    iconName: IconName;
    onClick: () => void;
    testId?: string;
  };
  rightIcon?: {
    iconName: IconName;
    onClick: () => void;
    testId?: string;
  };
  title: {
    props?: TextProps;
    text: string;
  };
};

export const SideModal: FC<Props> = ({
  bottomButtons,
  className,
  content,
  fullwidth = false,
  header,
  isVisible,
  onBackgroundClick = () => {},
  placement = 'right',
  testId,
}) => {
  const handleModalBackgroundClick = (event: MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onBackgroundClick();
    }
  };

  return (
    <div className={classNames('side-modal-wrapper', { 'show-drawer': isVisible })} data-test={testId}>
      <div className={classNames(placement, className)} id="drawer">
        <section className="header" style={{ backgroundColor: header.backgroundColor ?? 'transparent' }}>
          {header.leftIcon ? (
            <div className="left-icon">
              <Icon
                colorName={COLORS.zulu.$08}
                name={header.leftIcon.iconName}
                onClick={header.leftIcon.onClick}
                testId={header.leftIcon.testId}
              />
            </div>
          ) : null}
          <Text color={COLORS.zulu.$08} size="MD" uppercase weight="bold" {...header.title.props}>
            {header.title.text}
          </Text>
          <div className="right-icon">
            {header.rightIcon ? (
              <Icon
                colorName={COLORS.zulu.$08}
                name={header.rightIcon.iconName}
                onClick={header.rightIcon.onClick}
                testId={header.rightIcon.testId}
              />
            ) : null}
          </div>
        </section>
        <section className={classNames('content', fullwidth && 'fullwidth')}>{content}</section>
        {bottomButtons ? <section className="footer">{bottomButtons}</section> : null}
      </div>
      <div data-test={partTestId(testId, 'overlay')} id="overlay" onClick={handleModalBackgroundClick}></div>
    </div>
  );
};
